import React, { useState } from "react";
import MainMenu from "../components/navigations/MainMenu";

const BuildingSafety = () => {
  const [embedURL] = useState(
    "https://drive.google.com/file/d/1fklLbWXMlvagDVFsQxPJwQQwu3zvZr56/preview"
  );

  return (
    <div className="relative">
      <div className="absolute top-0 left-0">
        <MainMenu bg="gray-900" />
      </div>
      <div className="py-32 max-w-6xl mx-auto">
        <div>
          <h1 className="text-center text-3xl font-serif pb-6">
            Building Safety
          </h1>
        </div>
        <iframe
          src={embedURL}
          width="92%"
          height="800"
          allow="autoplay"
        ></iframe>
      </div>
    </div>
  );
};

export default BuildingSafety;
